import Configs from '../configs';

const state = {
  localStore: true,
  stateVersion: Configs.VERSION.stakingBanner,
  reopenStakingBannerOn: 0
};

export default state;
